'use strict'

module.exports = typeof window !== 'undefined' && window
